<template>
  <div>
    <hero-bar :has-right-visible="true">
      <div slot="title">Calendario de Trabajo</div>
      <div slot="sub-title">Asignar horas de trabajo</div>
      <div slot="right">
        <div class="columns">
          <div class="column is-5">
            <b-field label="Jinete" label-position="inside" expanded>
              <rider-selector :value="riderId" @select="rider = $event" :params="{'user_status_id': 1}"/>
            </b-field>
          </div>
          <div class="column">
            <week-selector :start.sync="startWeekDay" :finish.sync="finishWeekDay"/>
          </div>
        </div>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <div class="columns">
        <div class="column">
            <weekly-calendar :start-week-day="startWeekDay" :finish-week-day="finishWeekDay" :user-id="riderId"/>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HeroBar from '@/components/HeroBar'
import RiderSelector from '@/components/RiderSelector'
import WeeklyCalendar from './components/WeeklyCalendar'
import WeekSelector from './components/WeekSelector'

import DailyWorkFilterService from '@/services/filters/DailyWorkFilterService'

export default {
  name: 'home',
  components: {
    HeroBar,
    WeeklyCalendar,
    WeekSelector,
    RiderSelector
  },
  created () {
    this.initFilters()
  },
  data () {
    return {
      startWeekDay: null,
      finishWeekDay: null,
      riderId: null,
      rider: null,
      horses: [],
      dates: []
    }
  },
  methods: {
    initFilters () {
      let filters = DailyWorkFilterService.getFilters(this.$route.query)
      this.startWeekDay = filters.from
      this.finishWeekDay = filters.to
      this.riderId = filters.rider
      // this.lessonSelect = filters.lesson
      this.updateParams()
    },
    getFormatedFilters () {
      let filters = {
        from: this.fromFormated,
        to: this.toFormated,
        rider: this.riderId
      }
      return filters
    },
    updateParams () {
      let formatedFilters = this.getFormatedFilters()
      DailyWorkFilterService.setStorageFilters(formatedFilters)
      // eslint-disable-next-line handle-callback-err
      this.$router.replace({ query: formatedFilters }).catch(err => {})
    },
    formatedDate (date) {
      let formatDate = this.$moment(date, 'YYYY-MM-DD')
      let dayDate = formatDate.date()
      let month = formatDate.format('MMMM')
      let year = formatDate.format('YYYY')
      return {
        day: dayDate,
        month: month,
        year: year
      }
    }
  },
  computed: {
    fromFormated () {
      return this.$moment(this.startWeekDay).format('YYYY-MM-DD')
    },
    toFormated () {
      return this.$moment(this.finishWeekDay).format('YYYY-MM-DD')
    }
  },
  watch: {
    startWeekDay () {
      this.updateParams()
    },
    finishWeekDay () {
      this.updateParams()
    },
    rider (value) {
      if (value) {
        this.riderId = value.id
      } else {
        this.riderId = null
      }
      this.updateParams()
    }
  }
}
</script>
